
import { types, actions } from './requests'
export const RUNREVERSEGEOCODING_TYPES = {
    ...types('RUNREVERSEGEOCODING'),
}
export const RUNREVERSEGEOCODING_ACTIONS = {
    ...actions('RUNREVERSEGEOCODING'),
}